import { keyMirror } from '~/util/helpers/keyMirror'
import { User } from './reducer'

export const ACTIONS = keyMirror(
  {
    INITIAL_USER_CHECK_DONE: null,
    LOGIN_SUCCESS: null,
    LOGOUT: null,
    EXPIRED: null,
    LOGGED_IN_WITH_BUSINESS_ACCOUNT: null,
    INITIAL_LOGGED_IN_USER: null,
  },
  'authentication'
)

export const initialUserCheckDone = () => ({
  type: ACTIONS.INITIAL_USER_CHECK_DONE,
})

export const loginSuccess = (user: User) => ({
  type: ACTIONS.LOGIN_SUCCESS,
  payload: {
    user,
  },
})

export const logout = () => ({
  type: ACTIONS.LOGOUT,
})

export const loggedInWithBusinessAccount = () => ({
  type: ACTIONS.LOGGED_IN_WITH_BUSINESS_ACCOUNT,
})

export const expired = () => ({
  type: ACTIONS.EXPIRED,
})

export const initialLoggedInUser = (user: User) => ({
  type: ACTIONS.INITIAL_LOGGED_IN_USER,
  payload: {
    user,
  },
})

export type InitalLoggedInUser = {
  type: typeof ACTIONS.INITIAL_LOGGED_IN_USER
  payload: {
    user: User
  }
}
